import Icon from '@atoms/Icon/Icon';
import IconSizeEnum from '@models/enums/IconSizeEnum';
import type { IconName } from '@models/IIcon';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import updateDataLayer from '@utils/helpers/gtm';

interface Props {
  readonly articleTitle: string;
  readonly dislikeIcon: IconName;
  readonly dislikeSubTitle: string;
  readonly dislikeTitle: string;
  readonly likeIcon: IconName;
  readonly likeSubTitle: string;
  readonly likeTitle: string;
}

const ArticleLikes = ({
  articleTitle,
  dislikeIcon,
  dislikeSubTitle,
  dislikeTitle,
  likeIcon,
  likeSubTitle,
  likeTitle,
}: Props) => {
  const handleLikeClick = (like: boolean) => {
    updateDataLayer({
      event: 'selectContent',
      content_type: 'article_engagement',
      link_text: like ? 'like' : 'dislike',
      article: articleTitle,
    });
  };

  return (
    <SoftLoadWrapper>
      <section
        className="overflow-x-auto text-black-100 dark:text-white"
        data-testid="CT-41-Article-Likes"
      >
        <div className="flex w-full flex-col overflow-hidden">
          <div className="scrollbar-hide relative w-full snap-x overflow-x-auto">
            <div className="flex w-full grid-flow-col flex-row gap-4 overflow-visible pl-5 md:grid md:px-0">
              <button
                type="button"
                onClick={() => handleLikeClick(true)}
                className="shrink-0 snap-center"
                data-testid="CT-41-Article-Likes-Like-Button"
              >
                <div className="card flex h-full flex-row items-center gap-5 p-5 pr-10 md:gap-7.5 md:p-7.5">
                  <Icon
                    name={likeIcon}
                    colorClassName="text-yellow"
                    size={IconSizeEnum.lg}
                  />
                  <div>
                    <p
                      className="body-two text-left"
                      data-testid="CT-41-Article-Likes-Like-Button-Title"
                    >
                      {likeTitle}
                    </p>
                    <p
                      className="body-three text-left"
                      data-testid="CT-41-Article-Likes-Like-Button-Subtitle"
                    >
                      {likeSubTitle}
                    </p>
                  </div>
                </div>
              </button>

              <button
                type="button"
                onClick={() => handleLikeClick(false)}
                className="shrink-0 snap-center pr-5 md:pr-0"
                data-testid="CT-41-Article-Likes-Dislike-Button"
              >
                <div className="card flex h-full flex-row items-center gap-5 p-5 pr-10 md:gap-7.5 md:p-7.5">
                  <Icon
                    name={dislikeIcon}
                    colorClassName="text-yellow"
                    size={IconSizeEnum.lg}
                  />
                  <div>
                    <p
                      className="body-two text-left"
                      data-testid="CT-41-Article-Likes-Dislike-Button-Title"
                    >
                      {dislikeTitle}
                    </p>
                    <p
                      className="body-three text-left"
                      data-testid="CT-41-Article-Likes-Dislike-Button-Subtitle"
                    >
                      {dislikeSubTitle}
                    </p>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section>
    </SoftLoadWrapper>
  );
};

export default ArticleLikes;
